import { initialState, reducer } from '../reducer/reducers';
import { useActions } from '../actions/index';
import React, { createContext, useReducer } from 'react';

const StoreContext = createContext(initialState);

const StoreProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const actions = useActions(state, dispatch);
    return <StoreContext.Provider value={{ state, dispatch, actions }}>{children}</StoreContext.Provider>;
};

export { StoreContext, StoreProvider };
